var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPartner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Hospital Building"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.99992 2.66667C2.52716 2.66667 1.33325 3.86058 1.33325 5.33333V11.3333C1.33325 12.4379 2.22868 13.3333 3.33325 13.3333H9.33325H9.99992H10.6666H12.6666C13.7712 13.3333 14.6666 12.4379 14.6666 11.3333V8.66667C14.6666 7.19391 13.4727 6 11.9999 6H10.6666V5.33333C10.6666 3.86058 9.47268 2.66667 7.99992 2.66667H3.99992ZM10.6666 7.33333V12H12.6666C13.0348 12 13.3333 11.7015 13.3333 11.3333V8.66667C13.3333 7.93029 12.7363 7.33333 11.9999 7.33333H10.6666ZM9.33325 6V5.33333C9.33325 4.59695 8.7363 4 7.99992 4H3.99992C3.26354 4 2.66659 4.59695 2.66659 5.33333V11.3333C2.66659 11.7015 2.96506 12 3.33325 12H9.33325V6.66667V6Z",
    fill: "#FF66A9",
    stroke: "white",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_2",
    d: "M4.66675 11.3333C4.66675 10.9651 4.96523 10.6667 5.33341 10.6667H6.66675C7.03494 10.6667 7.33342 10.9651 7.33342 11.3333V13.3333H4.66675V11.3333Z",
    fill: "#FF66A9",
    stroke: "white",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 5.33333C5.63181 5.33333 5.33333 5.63181 5.33333 6V6.66667H4.66667C4.29848 6.66667 4 6.96514 4 7.33333C4 7.70152 4.29848 8 4.66667 8H5.33333V8.66666C5.33333 9.03485 5.63181 9.33333 6 9.33333C6.36819 9.33333 6.66667 9.03485 6.66667 8.66666V8H7.33333C7.70152 8 8 7.70152 8 7.33333C8 6.96514 7.70152 6.66667 7.33333 6.66667L6.66667 6.66667V6C6.66667 5.63181 6.36819 5.33333 6 5.33333Z",
    fill: "#FF66A9",
    stroke: "white",
    strokeWidth: 0.3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartner);
export default __webpack_public_path__ + "static/media/partner.607ef31ef5c2c856929ca255871213e9.svg";
export { ForwardRef as ReactComponent };